export const listBillingProviders = `
   query listBillingProviders($filter: BillingProvidersFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listBillingProviders(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              key
              name
              description
              status
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getBillingProvider = `
   query getBillingProvider($id:ID!) {
       getBillingProvider(id:$id) {
         id
         key
         name
         description
         status    
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         created
         updated
       } 
}`;
